import { Theme } from '@mui/material/styles';

export const tile = (theme: Theme) => ({
    boxShadow: theme.paperShadow,
    marginTop: theme.spacing(6.25),
    paddingTop: theme.spacing(4.375),
    paddingBottom: theme.spacing(3.125),
    paddingX: theme.spacing(5),
    position: 'relative',

    '&:first-of-type': {
        marginTop: 0,
    },
}) as const;

export const title = (theme: Theme) => ({
    color: 'text.secondary',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    fontSize: 18,
    position: 'relative',
    height: '100%',
    marginBottom: theme.spacing(2.5),
    paddingBottom: theme.spacing(0.625),
    paddingRight: 0,
    textAlign: 'left',
    border: 'none',

    [theme.breakpoints.up('lg')]: {
        marginBottom: 0,
        marginRight: theme.spacing(5),
        paddingBottom: 0,
        paddingRight: theme.spacing(4.375),
        textAlign: 'right',
        borderRight: '2px solid',
        borderColor: 'whiteSmoke.main',
    },
}) as const;
